const canDebug = import.meta.env.DEV

export function debugLog(...args: unknown[]) {
  if (canDebug) {
    console.log(...args)
  }
}

export function reportError(message: string, error?: unknown, extra?: unknown) {
  if (extra !== undefined) {
    console.error(message, error, extra)
    return
  }

  if (error !== undefined) {
    console.error(message, error)
    return
  }

  console.error(message)
}
